<template>
	<div class="containerPage">
		<div class="content">
			<div>
				<span
					style="font-size: 20px; border-bottom: solid #ff000;">{{$t('signingManagement.BookInformation')}}</span>
			</div>
			<el-divider></el-divider>
			<el-form label-position="right" :model="ruleForm" status-icon :rules="rules" ref="ruleForm"
				label-width="150px" class="demo-ruleForm my-ruleForm">
				<div>
					<div class="fl" v-model="worksData.data.works.converPath">
						<el-image style="width: 225px; height: 300px; margin:0 30px 20px 10px"
							:src="baseApi +'/'+ ruleForm.converPath" :fit="fit">
						</el-image>

						<el-upload class="upload-demo uploadimg" :action="coverPathurl"
							:on-success="handleAvatarSuccess" multiple :limit="1" :file-list="fileList"
							:before-upload="beforeAvatarUpload" style="width: 200px;">
							<!-- <el-button style="background-color: #409eff;" size="small" type="primary">
								{{$t('signingManagement.change_photo')}}</el-button> -->
							<div slot="tip" class="el-upload__tip">{{$t('newWork.only_upload')}}</div>
						</el-upload>
					</div>
					<div class="fl">
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.titles')" prop="worksName">
									<span>{{ruleForm.worksName}}</span>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.BookID')" prop="bookNo">
									<span>{{ruleForm.bookNo}}</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.AutgorsPenName')" label-width="150px"
									prop="userName">
									<span>{{userInfo.pseudonym}}</span>
									<!-- 作家前端用用户是userInfo 后台管理是用作品提交的 -->
									<!-- <span>{{ruleForm.userName}}</span> -->
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.DailyUpdated')" prop="dailyUpdated">
									<el-select :disabled='!isAuthor' v-model="ruleForm.dailyUpdated"
										:placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in loptions" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.PeriodEra')" prop="periodOrEra">
									<el-select v-model="ruleForm.periodOrEra"
										:placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in Poptions" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.Status')" prop="status">
									<el-select v-model="ruleForm.status" :placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in Soptions" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.WordsReleased')" label-width="150px"
									prop="words">
									<span>{{ruleForm.estimateWords}}</span>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.TotalWords')" prop="estimateWords">
									<span>{{ruleForm.words}}</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.Gener')" :required='true' :error="generErr">
									<el-select v-model="gener" :placeholder="$t('signingManagement.choose')"
										@change="selectedGener">
										<el-option v-for="item in goptions" :key="item.id" :label="item.typeName"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.reviewState')" prop="reviewState">
									<span
										v-if="ruleForm.reviewState == 100">{{$t('signingManagement.waiteAudit')}}</span>
									<span v-if="ruleForm.reviewState == 1">{{$t('signingManagement.pass')}}</span>
									<span
										v-if="ruleForm.reviewState == 2">{{$t('signingManagement.shenhe')}}{{$t('signingManagement.noPass')}}</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.BookRating')" :required='true'
									:error="bookRatingErr">
									<el-select v-model="bookRating" :placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in broptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<!-- 	<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.Period')" prop="updateDateTime">
									<span>{{ruleForm.createDateTime}}</span>
								</el-form-item>
							</el-col> -->
						</el-row>
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.Language')" :required='true'
									:error="languageErr">
									<el-select v-model="language" :placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in Lgoptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('newWork.writing_type')" :required='true'
									:error="writingtypeErr">
									<el-select v-model="writingtype" :placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in Woptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>

							</el-col>
						</el-row>
						<el-row>
							<el-col :span='12'>
								<el-form-item :label="$t('signingManagement.objective_reader')" :required='true'
									:error="leadingGenderErr">
									<el-select v-model="selectedTargetReader"
										:placeholder="$t('signingManagement.choose')">
										<el-option v-for="item in troptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span='12'>
								<el-form-item :label="$t('newWork.editor')">
									<el-radio :disabled="hadEditor" v-model="radio" label='1'
										@input="cheageRadio">Assigned by system</el-radio>
									<el-radio :disabled="hadEditor" v-model="radio" label='2'>Enter the code of your
										editor</el-radio>

									<el-select v-model="ruleForm.editorId" :disabled="radio=='1'||hadEditor"
										@change="selectchange" placeholder="Enter the code of your editor">
										<el-option v-for="item in editoroptions" :key="item.value" :label="item.value"
											:value="item.value">
										</el-option>
									</el-select>

								</el-form-item>

							</el-col>
						</el-row>
						<!-- 						<el-form-item :label="$t('signingManagement.objective_reader')" :required= 'true' :error="leadingGenderErr">
							<el-select v-model="selectedTargetReader" :placeholder="$t('signingManagement.choose')">
								<el-option v-for="item in troptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->

						<!-- tags -->
						<el-form-item :label="$t('signingManagement.Tags')" :required="true" :error='tagsErr'>
							<!-- <el-tabs  v-model="activeName" @tab-click="handleClick"> -->
							<!-- <el-tab-pane class="topics-items" v-for="(b,index) in bigTagsList" :label="b.typeName" :name="index+''">
									<span class="tag" :class="{'tag-active':item.select}" v-for="item,i in b.children"
										@click="tagClick(index,i)">{{item.typeName}}
									</span>
								</el-tab-pane> -->
							<!-- <tabsList :bigTagsList="bigTagsList"></tabsList> -->

							<!-- </el-tabs> -->

							<el-tabs v-model="tagsactiveName" @tab-click="handleClick">
								<el-tab-pane v-for="(b,index) in tagList" class="topics-items" :label="b.labelname"
									:name="index+''">
									<div style="display: flex;align-items: start;">
										<div class="left">
											<div v-for="item,i in b.children" :key="i" class="left-item"
												:class="{'leftItemActive':tagActiveIndex===i,'leftItemDisabled':item.disabled}"
												@click="handleTagItemClick(index,i)">
												{{ item.labelname }}
											</div>
										</div>
										<div class="tagBox">
											<div v-for="tagItem,i in tagActiveList" class="tag"
												:class="{'tag-active':tagItem.select}"
												@click="tagClick(index,tagActiveIndex,i)">{{ tagItem.labelname }}
												<!-- <img v-show="i<3" class="fire_img" src="../../static/images/preference/tagfire.png" alt=""> -->
											</div>
										</div>
									</div>
								</el-tab-pane>
							</el-tabs>
						</el-form-item>
						<!-- 						</el-col>
						</el-row> -->
						<!-- <el-form-item :label="$t('signingManagement.Language')" prop="language">
								<el-select v-model="language" :placeholder="$t('signingManagement.choose')">
									<el-option v-for="item in Lgoptions" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label="$t('signingManagement.Theme')"  prop="theme">
								<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content1')" v-model="ruleForm.theme">
								</el-input>
							</el-form-item>
							<el-form-item :label="$t('signingManagement.StoryBackground')"  prop="storyBackground">
							<el-tooltip class="mainCharacters_box" effect="dark" content="Tip: Personality, appearance, career, plus, what make this character catchy that different from the other stories? " placement="top-start">
								<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content1')" v-model="ruleForm.storyBackground">
								</el-input>
							</el-tooltip>
							</el-form-item>
							<el-form-item :label="$t('signingManagement.BookIdea')"  prop="BookIdea">
							<el-tooltip class="mainCharacters_box" effect="dark" content="Tip: Building a story skeleton, including the story's beginning, development, conflicts, climax (how to solve the conflicts) and ending.(Within 300 words) " placement="top-start">
								<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content1')" v-model="ruleForm.BookIdea">
								</el-input>
							</el-tooltip>
							</el-form-item> -->

					</div>

				</div>

				<div class="application clearfix">
					<!-- <el-divider></el-divider> -->
					<span>{{$t('signingManagement.ApplicationInformation')}}</span>
				</div>
				<el-divider></el-divider>
				<!-- <el-form-item :label="$t('signingManagement.Description')" label-width="300px" prop="Description">
					<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content1')" v-model="ruleForm.description">
					</el-input>
				</el-form-item> -->

				<el-form-item :label="$t('signingManagement.WorkSource')" label-width="300px" prop="worksSource">
					<!-- 					<el-select v-model="worksSource" :placeholder="$t('signingManagement.choose')">
						<el-option v-for="item in workSoptions" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select> -->
					<!-- <span v-if="isAuthor">{{ruleForm.worksHighights}}</span> -->
					<el-input type="text" :rows="2" v-model="ruleForm.worksSource">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('signingManagement.URL')" label-width="300px" prop="worksLinkSrc">
					<!-- <span v-if="isAuthor">{{ruleForm.worksHighights}}</span> -->
					<el-tooltip class="mainCharacters_box" effect="dark"
						content="Tip: If this story has been previously published online, kindly share the link to the original source. The story's prior performance will also be factored into our evaluation. "
						placement="top-start">
						<el-input type="textarea" :rows="2" v-model="ruleForm.worksLinkSrc">
						</el-input>
					</el-tooltip>

					<!-- <el-input  type="textarea" :rows="2" v-model="ruleForm.worksLinkSrc">
					</el-input> -->
				</el-form-item>

				<el-form-item :label="$t('signingManagement.ApplyTime')" label-width="300px">
					<!-- 					<el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.applyTime" type="datetime"
						:placeholder="$t('signingManagement.date')">
					</el-date-picker> -->
					<span>{{ruleForm.applyTime!=null?(ruleForm.applyTime.toString().replace("T"," ")+" (UTC+0)"):(dateTime)}}</span>
				</el-form-item>

				<!-- <el-form-item :label="$t('signingManagement.TheSetting')" label-width="300px" prop="setting">
				<el-tooltip class="mainCharacters_box" effect="dark" content="Tip: Personality, appearance, career, plus, what make this character catchy that different from the other stories? " placement="top-start">
						<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content1')" v-model="ruleForm.setting">
						</el-input>
					</el-tooltip>
				</el-form-item> -->

				<el-form-item :label="$t('signingManagement.TheMainCharacters')" label-width="300px" :required="true"
					prop="mainCharacters">
					<el-tooltip class="mainCharacters_box" effect="dark"
						content="Tip: including their ages, occupations, roles, and relations with each other "
						placement="top-start">
						<el-input type="textarea" :rows="4" :placeholder="$t('signingManagement.content01')"
							v-model="ruleForm.mainCharacters">
						</el-input>
					</el-tooltip>
				</el-form-item>

				<el-form-item :label="$t('signingManagement.ThePlot')" label-width="300px" prop="plot">
					<el-tooltip class="mainCharacters_box" effect="dark"
						content="Tip:  as detailed as possible, and shall include the start, the development, the climax, the end, and the main conflicts"
						placement="top-start">
						<el-input type="textarea" :rows="3" :placeholder="$t('signingManagement.content1')"
							v-model="ruleForm.plot">
						</el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item :label="$t('signingManagement.wmt')" label-width="300px" prop="storyAttractive">
					<el-input type="textarea" :rows="3" :placeholder="$t('signingManagement.content1')"
						v-model="ruleForm.storyAttractive">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('signingManagement.tenow')" label-width="300px" prop="estimateWords">
					<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.estimateWords')"
						v-model="ruleForm.estimateWords">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('signingManagement.wpeoa')" label-width="300px" prop="episodeWords">
					<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.episodeWords')"
						v-model="ruleForm.episodeWords">
					</el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('signingManagement.PersonalIntroduction')" label-width="300px">
					<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content1')"
						v-model="ruleForm.introduction">
					</el-input>
				</el-form-item> -->
				<el-form-item :label="$t('signingManagement.Email')" label-width="300px" prop="email">
					<el-input type="textarea" :rows="2" :placeholder="$t('signingManagement.content02')"
						v-model="ruleForm.email">
					</el-input>
					<!-- <span>{{userInfo.userEmail}}</span> -->
				</el-form-item>
				<el-form-item :label="$t('signingManagement.Birthday')" label-width="300px" prop="birthday">
					<el-date-picker v-model="ruleForm.birthday" type="date"
						:placeholder="$t('signingManagement.chooseDate')">
					</el-date-picker>
					<!-- <span>{{ruleForm.birthday}}</span> -->
				</el-form-item>
				<el-form-item :label="$t('signingManagement.Link')" label-width="300px" prop="link">
					<el-input type="textarea" :rows="3" :placeholder="$t('signingManagement.content1')"
						v-model="ruleForm.link">
					</el-input>
				</el-form-item>

				<div class="application clearfix" v-if="false">
					<span>{{$t('signingManagement.ChapterDescrition')}}</span>
				</div>
				<el-divider v-if="false"></el-divider>

				<!-- <...> -->
				<el-form :model="chapterDescrition" size="mini" :rules="rules" ref="chapterDescrition" v-if="false">
					<div class="chapter_descrition" v-for="(chapter,index) in chapterDescrition.chapterList"
						:key="index">
						<!-- 						<el-form-item :label="'chapter' + chapter.chapterId"
							label-widt:placeholder="$t('signingManagement.content02')"
							:placeholder="$t('signingManagement.content02')" v-model="chapter.chapterName">
							</el-input>
						</el-form-item> -->
						<!-- :prop="'chapterList.'+ index +'.chapterStart' -->
						<!-- content="1. Main characters should appear at the beginning of chapter 1.2.Tell the story simply and in a narrative style, don't include a lot of dialogue in the outline.3. Leave an engaging. cliffhanger at the end of each chapter.	" -->
						<!-- <el-form-item :label="$t('signingManagement.chapterContent')+' '+ chapter.chapterId +' ' + chapter.chapterName" -->
						<el-form-item :label="$t('signingManagement.chapterContent')+' '+ [index+1]" label-width="300px"
							:required="index<3" :error="chapterConten[index+1]">
							<el-popover class="mainCharacters_box" placement="top-start" title="Tip:" width="900"
								trigger="hover" :content="$t('signingManagement.chaContentTip')">
								<el-input class="chapterContent" slot="reference" type="textarea" :rows="12"
									:placeholder="$t('signingManagement.content02')" v-model="chapter.chapterStart"
									:disabled="true">
								</el-input>
							</el-popover>
						</el-form-item>
						<!-- 修改为提交整章内容 -->
						<!-- 							<el-form-item :label="$t('signingManagement.chapterMiddle')+' '+ chapter.chapterId" label-width="300px" :prop="'chapterList.'+ index +'.chapterMiddle'" :rules="rules.chapterMiddle">

								<el-popover
								    class="mainCharacters_box"
								    placement="top-start"
								    title="Tip:"
								    width="900"
								    trigger="hover"
								    content="1. Main characters should appear at the beginning of chapter 1.2.Tell the story simply and in a narrative style, don't include a lot of dialogue in the outline.3. Leave an engaging. cliffhanger at the end of each chapter.	">
										<el-input slot="reference"  type="textarea" :rows="2" :placeholder="$t('signingManagement.content02')" v-model="chapter.chapterMiddle">
										</el-input>
								  </el-popover>
							</el-form-item> -->
						<!-- 							<el-form-item :label="$t('signingManagement.chapterEnd')+' '+ chapter.chapterId" label-width="300px" :prop="'chapterList.'+ index +'.chapterEnd'" :rules="rules.chapterEnd">

								<el-popover
								    class="mainCharacters_box"
								    placement="top-start"
								    title="Tip:"
								    width="900"
								    trigger="hover"
								    content="1. Main characters should appear at the beginning of chapter 1.2.Tell the story simply and in a narrative style, don't include a lot of dialogue in the outline.3. Leave an engaging. cliffhanger at the end of each chapter.	">
										<el-input slot="reference"   type="textarea" :rows="2" :placeholder="$t('signingManagement.content02')" v-model="chapter.chapterEnd">
										</el-input>
								  </el-popover>
							</el-form-item> -->
					</div>
				</el-form>
				<!-- <...> -->

				<div class="application clearfix">
					<span>{{$t('signingManagement.Opinions')}}</span>
				</div>
				<el-divider></el-divider>
				<el-form-item :label="$t('signingManagement.PrimaryEditor')" label-width="300px"
					prop="primaryEditorName" v-if="false">
					<!-- <span>{{ruleForm.primaryEditorName}}</span> -->
					<el-input :disabled="isAuthor" type="text" v-model="ruleForm.primaryEditorName">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('signingManagement.identitles')" label-width="300px" prop="identity"
					v-if="false">
					<span>{{ruleForm.primaryEditorId}}</span>
				</el-form-item>
				<el-form-item :label="$t('signingManagement.PlotFramework')" label-width="300px" prop="title">
					<el-radio-group :disabled="isAuthor" v-model="ruleForm.scorePlotFrameWork"
						@change='selectPlotpoints'>
						<el-radio :label="p.label" v-for="p in points">{{p.label}}points</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item :label="$t('signingManagement.CharactersIntroduction')" label-width="300px" prop="title">
					<el-radio-group :disabled="isAuthor" v-model="ruleForm.scoreCharactersIntroduction"
						@change='selectidpoints'>
						<el-radio :label="p.label" v-for="p in points">{{p.label}}{{$t('signingManagement.points')}}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item :label="$t('signingManagement.Evaluation')" label-width="300px" prop="title">
					<el-radio-group :disabled="isAuthor" v-model="ruleForm.socreWritingEvaluation"
						@change='selectwStylePoints'>
						<el-radio :label="p.label" v-for="p in points">{{p.label}}{{$t('signingManagement.points')}}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item :label="$t('signingManagement.WorkHighights')" label-width="300px" prop="worksHighights">
					<!-- <span v-if="isAuthor">{{ruleForm.worksHighights}}</span> -->
					<el-input :disabled="isAuthor" type="textarea" :rows="2" v-model="ruleForm.worksHighights">
					</el-input>
				</el-form-item>

				<el-form-item :label="$t('signingManagement.WorkShortcomings')" label-width="300px"
					prop="worksShortcomings">
					<!-- <span v-if="isAuthor">{{ruleForm.worksHighights}}</span> -->
					<el-input :disabled="isAuthor" type="textarea" :rows="2" v-model="ruleForm.worksShortcomings">
					</el-input>
				</el-form-item>

				<!--<el-form-item :label="$t('signingManagement.reviewState')"  label-width="300px"
					prop="reviewState">
					<el-radio-group v-model="ruleForm.reviewState" @change='changeReviewState'>
						<el-radio :label='1'>{{$t('signingManagement.pass')}}</el-radio>
						<el-radio :label='2'>{{$t('signingManagement.noPass')}}</el-radio>
					</el-radio-group>
				</el-form-item> -->

				<el-form-item :label="$t('signingManagement.signStatus')" label-width="300px" prop="reviewState">
					<el-radio-group v-model="ruleForm.signStatus" @change='changeSignStatus' :disabled="isAuthor">
						<el-radio :label='1'>{{$t('signingManagement.pass')}}</el-radio>
						<el-radio :label='2'>{{$t('signingManagement.noPass')}}</el-radio>
						<!-- <el-radio :label='4'>{{$t('signingManagement.successful')}}</el-radio> -->
					</el-radio-group>
				</el-form-item>

				<el-form-item :label="$t('signingManagement.rejectReason')" label-width="300px"
					v-show="ruleForm.signStatus==2" prop="reviewState">
					<el-input :disabled="isAuthor" v-show="ruleForm.signStatus==2" type="textarea" :rows="2"
						v-model="ruleForm.refuseReason" style="width: 1005;">
					</el-input>
				</el-form-item>

				<div class="application">
					<span>{{$t('signingManagement.ContractS')}}</span>
				</div>

				<el-divider></el-divider>
				<el-form-item label="Contract type" prop="title">
					<el-select v-model="ruleForm.signType" :placeholder="$t('signingManagement.choose')">
						<el-option v-for="item in Sigoptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button v-if="isAuthor" type="primary" @click="submitForm('ruleForm')">
						{{$t('signingManagement.submit')}}</el-button>
					<el-button v-else type="primary" @click="updateAuthorWorksInfo">
						{{$t('signingManagement.save')}}
					</el-button>
					<el-button v-if="isAuthor" @click="resetForm('ruleForm')">{{$t('signingManagement.reset')}}
					</el-button>
					<el-button v-else type="warning" @click="routerBack">{{$t('signingManagement.return')}}
					</el-button>
				</el-form-item>

			</el-form>
		</div>
	</div>
</template>

<script>
import {
  addAuthorWorksSetting,
  // getAuthorWorksDictionaryList,
  getAuthorWorksTypeUser,
  getAuthorWorksInfo,
  updateAuthorSketchList,
  getAuthorSketchList,
  updateAuthorWorksInfo,
  getAuthorWorksSelectedDictionaryList,
  getAuthorWorksTypeByWorkId,
  updateAuthorWorksTypeShip,
  updateAuthorWorksSelectedDictionaryList,
  getTypesListByParents,
  getAuthorWorksTypeByWorkIdnew,
  getTypesListByParent,
  getEditorGroup,
  getWorksDictionaryList,
  getWorksSelectedDictionaryList,
  updateWorksSelectedDictionaryList,
  getAuthorChapterContentList
} from '../../common/api/works.js'

import {
  getEditorIdbyUserId,
  updateAuthorUserbyEditorId
} from '../../common/api/authorUser.js'

// } from '@/api/writerFunApi/works'
// import tabsList from "@/components/writerFun/tabsList.vue"
import tabsList from '@/components/tabsList.vue'
import {
  match
} from 'core-js/library/fn/symbol'
import {
  number
} from 'echarts'

import {
  apiGetLabelsByParm,
  apiGetLabelContactBook,
  apiSaveLableContactBook
} from '../../common/api/bookTag.js'
export default {
  components: {
    tabsList
  },
  watch: {
    gener (newVal, oldVal) {}
  },
  data () {
    var chapterName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('章节名不能为空'))
      }
      // setTimeout(() => {
      // 	if (!Number.isInteger(value)) {
      // 		callback(new Error('请输入数字值'));
      // 	} else {
      // 		if (value < 18) {
      // 			callback(new Error('必须年满18岁'));
      // 		} else {
      // 			callback();
      // 		}
      // 	}
      // }, 1000);
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    return {
      radio: '1',
      /* editoroptions1: [{
				  value: '112',
				  label: '1'
				}, {
				  value: '123',
				  label: '2'
				}, {
				  value: '133',
				  label: '3'
				}, {
				  value: '144',
				  label: '4'
				}], */
      /* editoroptions: [{
				  value: '112'
				}, {
				  value: '123'
				}, {
				  value: '133'
				}, {
				  value: '144'
				}], */
      hadEditor: false, // 一开始有责编则不让修改
      userId: 0,
      editoroptions: [],
      requiredData: {
        data: {
          page: 1,
          limit: 999
        }
      },
      bigTagsList: [{
        id: 1,
        typeName: 'typeName',
        select: false
      }],
      // dateTime:new Date(),
      // 自定义错误----------------
      generErr: '',
      bookRatingErr: '',
      tagsErr: '',
      languageErr: '',
      writingtypeErr: '',
      leadingGenderErr: '',
      chapterConten1: '112123123213',
      chapterConten2: '2',
      chapterConten3: '3',
      chapterConten4: '4',
      chapterConten: ['', '', '', ''],
      tagsactiveName: '0',
      tagActiveIndex: [],
      tagActiveList: [],
      tagList: [],
      // 自定义错误----------------
      dateTime: this.DateFormat(new Date()),
      fit: 'contain', // 确定图片如何适应容器框
      baseApi: process.env.VUE_APP_BASE_IMGS,
      userInfo: null,
      isAuthor: false, // 责编true作家false
      points: [], // 分数
      activeName: '0',
      bookId: 0,
      coverPathurl: process.env.VUE_APP_BASE_API + '/api/Files/UploadFile?dir=Imgs/BookCover/',
      fileList: [],
      gener: '',
      bookRating: '',
      language: '',
      writingtype: '',
      selectedTargetReader: '',
      worksSource: '',
      reviewState: 1,
      loptions: [{
        value: 'yes',
        label: 'yes'
      }, {
        value: 'no',
        label: 'no'
      }],
      value1: '',
      Soptions: [{
        value: 2,
        label: 'Complete'
      }, {
        value: 100,
        label: 'On-going'
      }],
      value2: 'Contemporary',
      Poptions: [{
        value: 'Contemporary',
        label: 'Contemporary'
      }, {
        value: 'Alternate-timeline',
        label: 'Alternate-timeline'
      }, {
        value: 'Historical',
        label: 'Historical'
      }, {
        value: 'Future',
        label: 'Future'
      }],
      Sigoptions: [ // 签约类型
        {
          value: 100,
          label: 'To choose'
        },
        {
          value: 1,
          label: 'exclusive'
        },
        {
          value: 2,
          label: 'non-exclusive'
        }
        // {
        // 	value: 100,
        // 	label: 'To choose'
        // }, {
        // 	value: 1,
        // 	label: 'A buyout'
        // }, {
        // 	value: 2,
        // 	label: 'Guaranteed'
        // }, {
        // 	value: 3,
        // 	label: 'Divided into'
        // }
      ],
      value: 'Contemporary',
      worksData: { // 提交的数据
        data: {
          works: { // 作品
            converPath: this.coverPathurl // 封面路径
          }
        }
      },
      ruleForm: {
        converPath: '',
        worksName: '',
        bookNo: '',
        userName: '',
        periodOrEra: 'Contemporary',
        dailyUpdated: 'yes',
        words: 0,
        estimateWords: '',
        episodeWords: '',
        updateDateTime: '',
        // gener: '',
        status: 0,
        // bookRating: '',
        // language: '',
        // selectedTargetReader:'',
        editorId: '', // 编辑对应的id
        description: '',
        applyTime: '', // apply time
        theme: '',
        setting: '',
        storyBackground: '',
        BookIdea: '',
        mainCharacters: '',
        plot: '',
        storyAttractive: '',
        birthday: '',
        estimateWords: '',
        episodeWords: '',
        introduction: '',
        email: '',
        link: '',
        primaryEditorName: '',
        primaryEditorId: '',
        scorePlotFrameWork: 10,
        scoreCharactersIntroduction: 10,
        socreWritingEvaluation: 10,
        worksHighights: '',
        worksShortcomings: '',
        worksSource: '',
        worksLinkSrc: '',
        reviewState: 100,
        signType: '',
        signStatus: 3
      },
      chapterDescrition: {
        chapterList: [{
          id: 1,
          workId: 0,
          chapterId: 1,
          chapterName: '',
          chapterStart: '',
          chapterMiddle: '',
          chapterEnd: '',
          status: 0,
          reviewerId: 0,
          reviewerName: ''
        }]

      },
      workSoptions: [{ // 文章来源
        value: 'purchase',
        label: 'purchase'
      }],
      goptions: [{
        value: 'romance',
        label: 'romance'
      }, {
        value: 'romance2',
        label: 'romance2'
      }],
      broptionValue: '',
      broptions: [{
        value: '18+',
        label: '18+'
      }, {
        value: '18-',
        label: '18-'
      }],
      Lgoptions: [{
        value: 'CN',
        label: 'cn'
      }, {
        value: 'EN',
        label: 'en'
      }],
      Woptions: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }],
      // 目标读者
      troptions: [{
        value: 'short story',
        label: 'short story'
      }, {
        value: 'long story',
        label: 'long story'
      }],
      // 验证
      rules: {
        dailyUpdated: [{
          required: true,
          message: 'unselected',
          trigger: 'change'
        }],
        periodOrEra: [{
          required: true,
          message: 'unselected',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: 'unselected',
          trigger: 'change'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Please fill in the email',
          trigger: ['blur', 'change']
        }],
        // gener: [{
        // 	required: true,
        // 	message: 'unselected',
        // 	trigger: 'change'
        // }],
        // language: [{
        // 	required: true,
        // 	message: 'unselected',
        // 	trigger: 'change'
        // }],
        // selectedTargetReader: [{
        // 	required: true,
        // 	message: 'unselected',
        // 	trigger: 'change'
        // }],
        bookRating: [{
          required: true,
          message: 'unselected',
          trigger: 'change'
        }],
        theme: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'change'
        }],
        description: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        setting: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        BookIdea: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        storyBackground: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        // mainCharacters: [{
        // 	required: true,
        // 	message: '请输入内容',
        // 	trigger: 'blur',
        // }],
        // plot: [{
        // 	required: true,
        // 	message: '请输入内容',
        // 	trigger: 'blur'
        // }],
        // storyAttractive: [{
        // 	required: true,
        // 	message: '请输入内容',
        // 	trigger: 'blur'
        // }],
        estimateWords: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        episodeWords: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        episodeWords: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        introduction: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        chapterName: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
          // validator: chapterName, trigger: 'blur'
        }],
        chapterStart: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        chapterMiddle: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        chapterEnd: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        mainCharacters: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        plot: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }],
        storyAttractive: [{
          required: true,
          message: "Please kindly offer your story's merit",
          trigger: 'blur'
        }],
        birthday: [{
          required: true,
          message: 'Cannot be null',
          trigger: 'blur'
        }]
      },
      // tags
      checkboxGroup: [],
      selectTagsList: [{
        name: '标签一'
      },
      {
        name: '标签二'
      }
      ],
      tagsList: [{
        id: 1,
        name: 'Tone',
        children: [{
          id: 101,
          name: 'drama'
        },
        {
          id: 102,
          name: 'traedy'
        },
        {
          id: 103,
          name: 'conedy'
        }
        ]
      },
      {
        id: 2,
        name: 'Relatinship',
        children: [{
          id: 201,
          name: 'Relat1'
        },
        {
          id: 202,
          name: 'Relat2'
        },
        {
          id: 203,
          name: 'Relat3'
        }
        ]
      }
      ]
      // submitButton: '提交',

    }
  },
  created () {
    let query = JSON.parse(this.$route.query.params)
    this.userInfo = this.$store.state.userInfo
    this.bookId = query.bookId
    this.handleGetLabelList(this.bookId)
    this.isAuthor = !query.isOperator
    console.log('打印变量', query.bookId)
    this.getEditorGroups() // 获取作家管理权限的审校ID
    this.getTypesListByParents() // 获取tag数据
    this.getAuthorWorksDictionaryList() // 查询作品相关字典集合
    this.worksType() // 查询作品类型风格
    this.createpoints() // 创建统一 10个评分
    this.createpchapterDescrition() // 创建6个章节
    this.getAuthorChapterContentList()
    this.getAuthorWorksInfo() // 获取作品信息

    // this.getAuthorWorksSelectedDictionaryList()
  },
  methods: {
    cheageRadio (e) {
      if (this.editoroptions.length > 0) {
        let RandomNum = 0
        RandomNum = Math.random()
        let index = Math.round(RandomNum * (this.editoroptions.length - 1))
        this.ruleForm.editorId = this.editoroptions[index].value
      } else {
        this.ruleForm.editorId = 0
      }
    },
    selectchange (e) {
      console.log('selectchange', e)
      console.log('ruleForm.editorId', this.ruleForm.editorId)
    },
    changeSignStatus () {

    },
    getAuthorChapterContentList () {
      let data = {
        data: {
          bookId: this.bookId,
          page: 1,
          limit: 6,
          isASC: true
        }
      }
      getAuthorChapterContentList(data).then(res => {
        console.log('res', res)
        if (res.code == 0) {
          // this.chapterDescrition.chapterList = res.data.chapters
          for (let i = 0; i <= res.data.length - 1; i++) {
            this.chapterDescrition.chapterList[i].id = res.data[i].chapterId
            this.chapterDescrition.chapterList[i].chapterEnd = res.data[i].chapterEnd
            this.chapterDescrition.chapterList[i].chapterId = res.data[i].chapterId
            this.chapterDescrition.chapterList[i].chapterMiddle = res.data[i].chapterMiddle
            this.chapterDescrition.chapterList[i].chapterName = res.data[i].name
            this.chapterDescrition.chapterList[i].chapterStart = res.data[i].content.replaceAll(
              /<[^>]+>/g, '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&nbsp;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&ldquo;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&rdquo;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&lsquo;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&rsquo;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&sbquo;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&hellip;', '')
            this.chapterDescrition.chapterList[i].chapterStart = this.chapterDescrition
              .chapterList[i].chapterStart.replaceAll('&ndash;', '')
            this.chapterDescrition.chapterList[i].reviewerId = res.data[i].reviewerId
            this.chapterDescrition.chapterList[i].reviewerName = res.data[i].reviewerName
            this.chapterDescrition.chapterList[i].status = res.data[i].status
            this.chapterDescrition.chapterList[i].workId = res.data[i].workId
          }
        }
        console.log('this.chapterDescrition.chapterList', this.chapterDescrition.chapterList)
      })
    },
    handleInspection (index, childrenIndex, i) {
      if (this.tagList[index].children[childrenIndex].labelname === 'Sexual Orientation') {
        let num = 0
        for (let i = 0; i < this.tagList[index].children[childrenIndex].children.length; i++) {
          if (this.tagList[index].children[childrenIndex].children[i].select) {
            num++
          }
        }
        if (num >= 1) {
          return false
        } else {
          return true
        }
      } else if (this.tagList[index].children[childrenIndex].labelname === 'Scale') {
        let num = 0
        for (let i = 0; i < this.tagList[index].children[childrenIndex].children.length; i++) {
          if (this.tagList[index].children[childrenIndex].children[i].select) {
            num++
          }
        }
        if (num >= 1) {
          return false
        } else {
          return true
        }
      } else if (this.tagList[index].children[childrenIndex].labelname === 'Plot Twist') {
        let num = 0
        for (let i = 0; i < this.tagList[index].children[childrenIndex].children.length; i++) {
          if (this.tagList[index].children[childrenIndex].children[i].select) {
            num++
          }
        }
        if (num >= 1) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    tagClick (index, childrenIndex, i) {
      console.log('index', index)
      console.log('childrenIndex', childrenIndex)
      console.log('i', i)
      if (this.tagList[index].children[childrenIndex].children[i].select) {
        this.$set(this.tagList[index].children[childrenIndex].children[i], 'select', false)
        this.tagActiveList[i].select = false
      } else if (this.handleInspection(index, childrenIndex, i)) {
        this.$set(this.tagList[index].children[childrenIndex].children[i], 'select', !this.tagList[index]
          .children[
            childrenIndex].children[i].select)

        this.tagActiveList[i].select = !this.tagActiveList[i].select
      }
      if (this.tagList[index].children[childrenIndex].labelname === 'Modern') {
        let flag1 = false
        for (let j = 0; j < this.tagList[index].children[childrenIndex].children.length; j++) {
          if (this.tagList[index].children[childrenIndex].children[j].select === true) {
            flag1 = true
            for (let k = 0; k < this.tagList[index].children.length; k++) {
              if (this.tagList[index].children[k].labelname === 'Ancient') {
                this.tagList[index].children[k].disabled = true
              }
            }
          }
        }
        if (flag1 === false) {
          for (let k = 0; k < this.tagList[index].children.length; k++) {
            if (this.tagList[index].children[k].labelname === 'Ancient') {
              this.tagList[index].children[k].disabled = false
            }
          }
        }
      } else if (this.tagList[index].children[childrenIndex].labelname === 'Ancient') {
        let flag2 = false
        for (let j = 0; j < this.tagList[index].children[childrenIndex].children.length; j++) {
          if (this.tagList[index].children[childrenIndex].children[j].select === true) {
            flag2 = true
            for (let k = 0; k < this.tagList[index].children.length; k++) {
              if (this.tagList[index].children[k].labelname === 'Modern') {
                this.tagList[index].children[k].disabled = true
              }
            }
          }
        }
        if (flag2 === false) {
          for (let k = 0; k < this.tagList[index].children.length; k++) {
            if (this.tagList[index].children[k].labelname === 'Modern') {
              this.tagList[index].children[k].disabled = false
            }
          }
        }
      } else if (this.tagList[index].children[childrenIndex].labelname === 'Male-oriented') {
        console.log('执行这一步123abc')
        let flag2 = false
        for (let j = 0; j < this.tagList[index].children[childrenIndex].children.length; j++) {
          if (this.tagList[index].children[childrenIndex].children[j].select === true) {
            flag2 = true
            for (let k = 0; k < this.tagList[index].children.length; k++) {
              if (this.tagList[index].children[k].labelname === 'Female-oriented' || this.tagList[index]
                .children[k]
                .labelname === 'Other') {
                console.log('触发这里123ABC')
                this.tagList[index].children[k].disabled = true
              }
            }
          }
        }
        if (flag2 === false) {
          for (let k = 0; k < this.tagList[index].children.length; k++) {
            if (this.tagList[index].children[k].labelname === 'Female-oriented' || this.tagList[index]
              .children[k]
              .labelname === 'Other') {
              this.tagList[index].children[k].disabled = false
            }
          }
        }
      } else if (this.tagList[index].children[childrenIndex].labelname === 'Female-oriented') {
        let flag2 = false
        for (let j = 0; j < this.tagList[index].children[childrenIndex].children.length; j++) {
          if (this.tagList[index].children[childrenIndex].children[j].select === true) {
            flag2 = true
            for (let k = 0; k < this.tagList[index].children.length; k++) {
              if (this.tagList[index].children[k].labelname === 'Male-oriented' || this.tagList[index]
                .children[k]
                .labelname === 'Other') {
                this.tagList[index].children[k].disabled = true
              }
            }
          }
        }
        if (flag2 === false) {
          for (let k = 0; k < this.tagList[index].children.length; k++) {
            if (this.tagList[index].children[k].labelname === 'Male-oriented' || this.tagList[index]
              .children[k]
              .labelname === 'Other') {
              this.tagList[index].children[k].disabled = false
            }
          }
        }
      } else if (this.tagList[index].children[childrenIndex].labelname === 'Other') {
        let flag2 = false
        for (let j = 0; j < this.tagList[index].children[childrenIndex].children.length; j++) {
          if (this.tagList[index].children[childrenIndex].children[j].select === true) {
            flag2 = true
            for (let k = 0; k < this.tagList[index].children.length; k++) {
              if (this.tagList[index].children[k].labelname === 'Male-oriented' || this.tagList[index]
                .children[k]
                .labelname === 'Female-oriented') {
                this.tagList[index].children[k].disabled = true
              }
            }
          }
        }
        if (flag2 === false) {
          for (let k = 0; k < this.tagList[index].children.length; k++) {
            if (this.tagList[index].children[k].labelname === 'Male-oriented' || this.tagList[index]
              .children[k]
              .labelname === 'Female-oriented') {
              this.tagList[index].children[k].disabled = false
            }
          }
        }
      }

      // if (this.bigTagsList[index].children[i].select) {
      //   this.$set(this.bigTagsList[index], 'selectCount', this.bigTagsList[index].selectCount + 1)
      // } else {
      //   this.$set(this.bigTagsList[index], 'selectCount', this.bigTagsList[index].selectCount - 1)
      // }

      // this.bindTagCount(index,i)
      console.log('触发这里1', this.tagList)
    },
    // bindTagCount(index,i) {
    // 	this.tagCount = 0
    // 	this.bigTagsList[index].map(t => {
    // 		if (t.children.select) {
    // 			// this.tagCount++
    // 			console.log('tttttt',t);
    // 		}
    // 	})
    // 	if (this.tagCount > 5) {
    // 		this.$set(this.tags[index], 'select', false)
    // 		uni.showToast({
    // 			title: 'up to 5 tags are optional',
    // 			duration: 2000
    // 		});
    // 	}
    // },
    selectedGener () {
      this.generErr = ''
    },
    handleBuildTree (data, pid = 0) {
      return data
        .filter(item => item.pid === pid) // 过滤出父节点是 pid 的项
        .map(item => {
          const children = this.handleBuildTree(data, item.id) // 递归查找子节点
          return {
            ...item, // 展开原始数据项
            select: false,
            disabled: false,
            children: children.length ? children : undefined // 如果有子节点则添加，没有则忽略
          }
        })
    },
    handleGetLabelList (bookId) {
      // const data = {
      //   data: {
      //     bookId: parseInt(bookId)
      //   }
      // }
      // apiGetLabelContactBook(data).then((res) => {
      //   console.log('获取的数据', res)
      // })
      apiGetLabelsByParm({
        data: {}
      }).then((res) => {
        this.tagList = this.handleBuildTree(res.data)

        this.handleGetTagContact(bookId)

        console.log('标签list', this.tagList)
      })
    },
    handleGetTagContact (bookId) {
      const data = {
        data: {
          workId: parseInt(bookId),
          page: 1,
          limit: 100
        }
      }
      apiGetLabelContactBook(data).then((res) => {
        // this.handleUpdateSelectByLabelId(this.tagList, res.data)
        this.tagList.forEach((item) => {
          if (item.children && item.children.length > 0) {
            item.children.forEach((childrenItem) => {
              if (childrenItem.children && childrenItem.children.length > 0) {
                childrenItem.children.forEach((threeItem) => {
                  res.data.forEach((activeItem) => {
                    if (threeItem.id === activeItem
                      .labelid) {
                      threeItem.select = true
                      console.log('找到123')
                    }
                  })
                })
              }
            })
          }
        })
      }).finally(() => {
        console.log('修改后的tagList', this.tagList)
        this.handleTagItemClick(this.tagsactiveName, 0)
      })
    },
    handleTagItemClick (index, i) {
      if (this.tagList[index].children[i].disabled === false) {
        if (this.tagList[index].children && this.tagList[index].children[i].children) {
          this.tagActiveList = JSON.parse(JSON.stringify(this.tagList[index].children[i].children))
        } else {
          this.tagActiveList = [] // 或者根据你的需求设置一个默认值
        }
        this.tagActiveIndex = i
      }
    },
    // 切换标签
    handleClick (tab) {
      this.handleTagItemClick(this.tagsactiveName, 0)
      this.tagClick(this.tagsactiveName, 0, 0)
      this.tagClick(this.tagsactiveName, 0, 0)
    },
    // 获取tag数据
    async getTypesListByParents () { // 获取书籍类型信息列表
      let reqData = {
        data: {
          parentId: 84, // 这个大类是标签大类
          isShowParents: true
        }
      }
      const res = await getTypesListByParents(reqData)
      if (res.code == 0) {
        this.bigTagsList = this.tags_method(84, res.data, 'tag')
        // this.parseData(res.data)
        console.log('this.bigTagsList', this.bigTagsList)
        this.getAuthorWorksTypeByWorkId()
      }
      /* getTypesListByParents(reqData).then(res =>{

				}) */
    },
    // 递归 返回的字典
    tags_method (pid, list, mark) {
      let resList = []
      for (let i in list) {
        if (list[i].code == mark) {
          if (list[i].parentId == pid) {
            list[i].select = false
            list[i].selectCount = 0
            resList.push(list[i])
            list[i].children = this.tags_method(list[i].id, list)
          }
        }
      }
      return resList
    },
    // 文件上传成功时得钩子
    // <!-- :src="baseApi +'/'+ ruleForm.converPath" -->
    handleAvatarSuccess (res, file) {
      if (res.code == 0) {
        this.worksData.data.works.converPath = res.data[0]
        this.ruleForm.converPath = res.data[0]
      } else {
        this.$message.warning(`上传图片失败！${res.msg}`)
        this.fileList = []
      }
    },
    DateFormat (Time) { // 去掉括号里面的中文
      // var Datestring = new Date().toString();
      // var reDatestring = Datestring.slice(0, Datestring.indexOf("("))
      // var reDatestring = Datestring.slice(0, Datestring.indexOf("G"))
      const moment = require('moment-timezone')
      if (Time == null) {
        return null
      }
      var timezone = 'Asia/Shanghai'
      const clean = moment(Time).format('YYYY-MM-DD HH:mm:ss') // 清除 timezone 信息
      const Shanghailocal = moment.tz(clean, timezone)
      const applytime = new Date().toString().slice(0, 7) + ' ' + Shanghailocal.tz('UTC').format(
        'MM-DD-YYYY HH:mm:ss').slice(3).replace('-', ' ') + ' UTC+0'
      return applytime
    },
    // 限制图片上传大小
    beforeAvatarUpload (file) {
      // const isJPG = file.type === 'image/jpeg';
      let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png', 'image/webp', 'image/webp']
      const isJPG = types.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 0.1

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 100kb!')
      }
      return isJPG && isLt2M
    },
    handleChange () {

    },
    // 根据作品ID 获取作品类型
    async getAuthorWorksTypeByWorkId () {
      let data = {
        data: {
          workId: this.bookId
        }
      }
      // console.log("报错data",data)
      const res = await getAuthorWorksTypeByWorkId(data)

      if (res.code == 0) {
        // console.log("报错",res)
        if (res.data[0] != null) {
          this.gener = res.data[0].id
        }

        this.getAuthorWorksTypeByWorkIdnew()
      }
      /* getAuthorWorksTypeByWorkId(data).then(res => {
					if(res.code==0){
						console.log("报错",res)
						this.gener = res.data[0].id
						this.getAuthorWorksTypeByWorkIdnew()
					}

				}) */
    },
    // 根据ID查询书的类型
    getAuthorWorksTypeByWorkIdnew () {
      let data = {
        data: {
          workId: this.bookId
        }
      }
      getAuthorWorksTypeByWorkIdnew(data).then(res => {
        console.log('报错后续', res)
        if (res.code == 0) {
          for (let w in res.data) {
            for (let i in this.bigTagsList) {
              for (let j in this.bigTagsList[i].children) {
                // console.log('this.bigTagsList[i].children[j].id',this.bigTagsList[i].children[j].id);
                if (this.bigTagsList[i].children[j].id == res.data[w].workTypeId) {
                  this.bigTagsList[i].children[j].select = true
                  this.bigTagsList[i].selectCount += 1
                }
              }
            }
          }
        }
        console.log('getAuthorWorksTypeByWorkIdnew', res.data)
        console.log('getAuthorWorksTypeByWorkIdnew', this.bigTagsList)
      })
    },
    // 根据作品ID 获取作品类型
    // getAuthorWorksTypeByWorkId() {
    // 	let data = {
    // 		data: {
    // 			workId: this.bookId
    // 		}
    // 	}
    // 	getAuthorWorksTypeByWorkId(data).then(res => {
    // 		this.gener = res.data[0].id
    // 	})
    // },
    // 查询作品选中的相关字典集合
    getAuthorWorksSelectedDictionaryList () {
      let data = {
        data: {
          workId: this.bookId
        }
      }
      getAuthorWorksSelectedDictionaryList(data).then(res => {
        // getWorksSelectedDictionaryList(data).then(res => {
        if (res.code == 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].mark == 6) {
              this.bookRating = res.data[i].id
            } else if (res.data[i].mark == 7) {
              this.language = res.data[i].id
            } else if (res.data[i].mark == 1) {
              this.writingtype = res.data[i].id
            } else if (res.data[i].mark == 2) {
              this.selectedTargetReader = res.data[i].id
            }
          }
        }
      })
    },
    // 获取作品信息
    async getAuthorWorksInfo () {
      let data = {
        data: {
          id: this.bookId
        }
      }

      const res = await getAuthorWorksInfo(data)
      if (res.code == 0) {
        this.ruleForm = res.data
        if (res.data.episodeWords == '0') {
          this.ruleForm.episodeWords = ''
        }
        if (res.data.estimateWords == '0') {
          this.ruleForm.estimateWords = ''
        }
        this.userId = res.data.userId // 记录书籍对应的用户，用于后面保存作家对应责编
        this.getEditorIdbyUserId(res.data)

        // 获取 作品得章节简述
        // if(this.ruleForm.editorId != 0 && this.ruleForm.editorId!=null){
        // 	this.radio ='2'
        // }
        // else{
        // 	this.radio ='1'
        // 	this.cheageRadio()//随机选择
        // }

        this.getAuthorSketchList()
      }
      /*  getAuthorWorksInfo(data).then(res => {
					if (res.code == 0) {
						this.ruleForm = res.data
						// 获取 作品得章节简述
						if(this.ruleForm.editorId != 0&&this.ruleForm.editorId!=null){
							this.radio ='2'
						}
						else{
							this.radio ='1'
							this.cheageRadio()//随机选择
						}

						this.getAuthorSketchList()
					} else {

					}
				}) */
    },
    async getEditorIdbyUserId (data) {
      let reqdata = {
        data: {
          id: data.userId
        }
      }
      const res = await getEditorIdbyUserId(reqdata)

      // this.ruleForm.editorId=res.data
      if (res.data != null) {
        this.ruleForm.editorId = res.data.editorId
        if (this.ruleForm.editorId != 0 && this.ruleForm.editorId != null) {
          this.radio = '2'
        } else {
          this.radio = '1'
          this.cheageRadio() // 随机选择
        }
        console.log('getEditorIdbyUserId', this.ruleForm.email)
        if (this.ruleForm.email == null || this.ruleForm.email == '') {
          this.ruleForm.email = res.data.userEmail
        }
      }
      // console.log("res.data",res.data)
      // console.log("res.data>0",res.data.editorId>0)

      if (res.data != null && res.data.editorId >> 0) {
        this.hadEditor = true
        // console.log("this.hadEditor",this.hadEditor)
      }
    },
    // 获取 作品得章节简述
    getAuthorSketchList () {
      let data = {
        data: {
          page: 1,
          limit: 999,
          workIds: [this.bookId]
        }
      }
      getAuthorSketchList(data).then(res => {
        for (let i = 0; i <= res.data.length - 1; i++) {
          this.chapterDescrition.chapterList[i].id = res.data[i].id
          this.chapterDescrition.chapterList[i].chapterEnd = res.data[i].chapterEnd
          this.chapterDescrition.chapterList[i].chapterId = res.data[i].chapterId
          this.chapterDescrition.chapterList[i].chapterMiddle = res.data[i].chapterMiddle
          this.chapterDescrition.chapterList[i].chapterName = res.data[i].chapterName
          this.chapterDescrition.chapterList[i].chapterStart = res.data[i].chapterStart
          this.chapterDescrition.chapterList[i].reviewerId = res.data[i].reviewerId
          this.chapterDescrition.chapterList[i].reviewerName = res.data[i].reviewerName
          this.chapterDescrition.chapterList[i].status = res.data[i].status
          this.chapterDescrition.chapterList[i].workId = res.data[i].workId
        }
      })
    },
    // 查询作品类型风格
    worksType () {
      this.goptions = []
      let data = {
        data: {
          parentId: 2
        }
      }
      getTypesListByParent(data).then(res => {
        if (res.code == 0) {
          this.goptions = res.data
          // this.goptions = res.data.map(item => {
          // 	return {
          // 		value: `${item.name}`,
          // 		label: `${item.name}`,
          // 		id: `${parseInt(item.id)}`
          // 	}
          // })
          // 绑定了数据在去调
          // this.getAuthorWorksTypeByWorkId()
        }
      })
    },
    // 查询作品相关字典集合
    getAuthorWorksDictionaryList () {
      this.broptions = []
      this.Lgoptions = []
      this.tagsList = []
      this.workSoptions = []
      // getAuthorWorksDictionaryList(this.requiredData).then(res => {
      getWorksDictionaryList(this.requiredData).then(res => {
        if (res.code == 0) {
          let dictList = res.data
          this.Woptions = this.Recursive_method(0, dictList, 1)
          this.troptions = this.Recursive_method(0, dictList, 2)
          this.tagsList = this.Recursive_method(0, dictList, 5)
          this.broptions = this.Recursive_method(0, dictList, 6)
          this.Lgoptions = this.Recursive_method(0, dictList, 7)
          this.getAuthorWorksSelectedDictionaryList()
        } else {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        }
      })
    },
    async getEditorGroups () {
      const res = await getEditorGroup()
      if (res.code == 0) {
        this.editoroptions = res.data
        // this.cheageRadio()
        console.log('getEditorGroups', this.editoroptions)
      } else {
        this.$message({
          type: 'info',
          message: 'getEditorGroups canceled'
        })
      }
    },
    // 递归 返回的字典
    Recursive_method (pid, list, mark) {
      let resList = []
      for (let i in list) {
        if (list[i].mark == mark) {
          if (list[i].parentId == pid) {
            resList.push(list[i])
            list[i].children = this.Recursive_method(list[i].id, list, mark)
          }
        }
      }
      return resList
    },
    changeData (data) {
      let d = data
      return d.map(data => {
        return {
          value: `${data.name}`,
          label: `${data.name}`,
          id: `${parseInt(data.id)}`
        }
      })
    },
    // 生成统一 10个评分
    createpoints () {
      for (let i = 10; i >= 1; i--) {
        this.points.push({
          label: i
        })
      }
    },
    // 生成 提交6个章节的6个简述
    createpchapterDescrition () {
      this.chapterDescrition.chapterList = []
      // var str=['The Start Of Chapter 1','The Middle Of Chapter 1 ','The End Of Chapter 1',1,2,3,4,5,6]
      for (let i = 1; i <= 6; i++) {
        this.chapterDescrition.chapterList.push({
          workId: this.bookId,
          workName: '',
          status: 0,
          reviewerId: 0,
          reviewerName: '',
          chapterId: i,
          chapterName: '',
          chapterStart: '',
          chapterMiddle: '',
          chapterEnd: ''
        })
      }
    },
    // 选择剧情分数
    selectPlotpoints (e) {
      console.log('selectPlotpoints', e)
    },
    // 选择剧情分数
    selectidpoints (e) {
      console.log('selectPlotpoints', e)
    },
    // 选择剧情分数
    selectwStylePoints (e) {
      console.log('selectPlotpoints', e)
    },
    submitForm (formName) {
      this.$confirm('Submit to apply for a contact?', 'Tip:', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        let num2 = 0
        let num3 = 0
        let num5 = 0
        for (let i = 0; i < this.tagList.length; i++) {
          for (let j = 0; j < this.tagList[i].children.length; j++) {
            let num = 0
            for (let k = 0; k < this.tagList[i].children[j].children.length; k++) {
              if (this.tagList[i].children[j].children[k].select === true) {
                num++
              }
            }
            if (num === 0) {
              if (this.tagList[i].children[j].labelname === 'Sexual Orientation') {
                this.$message.warning("'Sexual orientation' is required!")
                return
              }
              if (this.tagList[i].children[j].labelname === 'Scale') {
                this.$message.warning("'Scale' is required!")
                return
              }
            }

            if (this.tagList[i].children[j].labelname === 'Modern' || this.tagList[i].children[j]
              .labelname ===
								'Ancient') {
              for (let x = 0; x < this.tagList[i].children[j].children.length; x++) {
                if (this.tagList[i].children[j].children[x].select === true) {
                  num2++
                }
              }
            }

            if (this.tagList[i].children[j].labelname === 'Male-oriented' || this.tagList[i]
              .children[j]
              .labelname ===
								'Female-oriented' || this.tagList[i].children[j].labelname === 'Other') {
              for (let x = 0; x < this.tagList[i].children[j].children.length; x++) {
                if (this.tagList[i].children[j].children[x].select === true) {
                  num3++
                }
              }
            }
            if (this.tagList[i].children[j].labelname === 'Identity/Race' || this.tagList[i]
              .children[j]
              .labelname ===
								'Personality') {
              for (let x = 0; x < this.tagList[i].children[j].children.length; x++) {
                if (this.tagList[i].children[j].children[x].select === true) {
                  num5++
                }
              }
            }
          }
        }
        if (num2 === 0) {
          this.$message.warning(
            "'Background world view - modern or fictional/ancient' at least select a third-level label!"
          )
          return
        }
        if (num5 === 0) {
          this.$message.warning(
            "'Personality - identity, race or personality' at least select a third-level label!"
          )
          return
        }
        if (num3 === 0) {
          this.$message.warning(
            "'Plot - male or female or other' at least select a third-level label!")
          return
        }
        for (let i = 0; i < this.tagList.length; i++) {
          let num = 0
          for (let j = 0; j < this.tagList[i].children.length; j++) {
            for (let k = 0; k < this.tagList[i].children[j].children.length; k++) {
              if (this.tagList[i].children[j].children[k].select === true) {
                num++
              }
            }
          }
          if (num > 999) {
            this.$message.warning(
              `'${this.tagList[i].labelname}'- You can only select up to five third-level labels.`
            )
            return
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let result = this.handlerWorksData()
            console.log('执行了这一步了吗')
            if (!result) {
              return
            }
            this.handleSaveTagContactBook()
            // 更新作品类型
            this.updateAuthorWorksTypeShip()
            // 更新作品信息
            this.updateAuthorWorksInfo()
            // 更新章节简述
            // this.SubmitChapter()
            // 更新作品字典集合信息
            this.updateAuthorWorksSelectedDictionaryList()
            // 更新作品类型
            // this.updateAuthorWorksTypeShip()
          } else {
            this.$message({
              type: 'info',
              message: 'Please kindly check again and fill in all the fields.'
            })
            return false
          }
        })
      }).catch((e) => {
        console.log('catch', e)
        this.$message({
          type: 'info',
          message: 'Operation canceled'
        })
      })
    },
    handleSaveTagContactBook () {
      const paramsList = {
        data: []
      }
      // 遍历 tagList 的每个节点
      this.tagList.forEach(item => {
        // 如果节点有 children，继续遍历
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => {
            // 如果子节点也有 children，遍历到第三级
            if (child.children && child.children.length > 0) {
              child.children.forEach(grandchild => {
                // 检查第三级的 select 是否为 true
                if (grandchild.select) {
                  // 执行某种操作
                  paramsList.data.push({
                    labelid: grandchild.id,
                    workid: this.bookId,
                    labelname: grandchild.labelname,
                    source: grandchild.source,
                    sourcename: grandchild.sourcename
                  })
                }
              })
            }
          })
        }
      })
      console.log('选中的数据参数', paramsList)
      apiSaveLableContactBook(paramsList).then((res) => {
        if (res.code == 0) {
          this.loading = false
        }
      })
    },
    // 去作品签署流程
    toViewProcess () {
      // console.log('item', item);
      this.$router.push({
        path: '/process/process',
        query: {
          params: JSON.stringify({
            bookId: this.bookId,
            isOperator: this.isOperator
          })
        }
      })
    },
    handlerWorksData () { // 处理提交的数据
      // 判断字典选项
      if (this.gener == '') {
        this.generErr = 'Please select the Gener of work'
        result = false
      } else {
        this.generErr = ''
      }
      if (this.bookRating == '') {
        this.bookRatingErr = 'Please select the Content Rating of work'
        result = false
      } else {
        this.bookRatingErr = ''
      }
      if (this.language == '') {
        this.languageErr = 'Please select the Language of work'
        result = false
      } else {
        this.languageErr = ''
      }
      if (this.writingtype == '') {
        this.writingtypeErr = 'Please select the Language of work'
        result = false
      } else {
        this.writingtypeErr = ''
      }
      if (this.selectedTargetReader == '') {
        this.leadingGenderErr = 'Please select the Leading Gender of work'
        result = false
      } else {
        this.leadingGenderErr = ''
      }
      // 判断标签
      let tagsCount = 0
      for (let i in this.bigTagsList) {
        for (let j in this.bigTagsList[i].children) {
          if (this.bigTagsList[i].children[j].select) {
            tagsCount++
          }
        }
      }
      // if (tagsCount < 2) {
      // 	this.$message({
      // 		showClose: true,
      // 		message: 'At least select two tags for your book',
      // 		type: 'error'
      // 	})
      // 	this.tagsErr = 'At least select two tags for your book'
      // 	return false
      // }
      // 判断章节内容
      var reg = new RegExp('\\b', 'gi')
      var allwords = 0
      this.chapterConten = []
      for (let i in this.chapterDescrition.chapterList) {
        try {
          var words = this.chapterDescrition.chapterList[i].chapterStart.match(reg).length / 2 // 单词个数
        } catch (e) {
          // TODO handle the exception
          words = 0
        }
        allwords += words
        if (i <= 2) {
          if (this.chapterDescrition.chapterList[i].chapterStart == '') {
            i++
            this.chapterConten[i] = 'Cannot be null'
            break
          }
        }
      }
      // if(allwords < 5000){
      // 	this.$message({
      // 		showClose: true,
      // 		message: 'The sample chapter should have more than 5,000 words in total.',
      // 		type: 'error'
      // 	})
      // 	return false
      // }else{
      // 	// this.chapterConten[i+1]=''
      // }
      return true
    },
    // 更新作品信息
    updateAuthorWorksInfo () {
      if (!this.isAuthor) {
        this.ruleForm.primaryEditorId = this.$store.state.user.userInfo.id
        this.ruleForm.primaryEditorName = this.$store.state.user.userInfo.nickName
      }
      let data = {
        data: this.ruleForm
      }
      this.ruleForm.applyTime = new Date()
      this.ruleForm.userName = this.userInfo.userName
      this.ruleForm.signStatus = 3
      this.ruleForm.editorId = parseInt(this.ruleForm.editorId)
      updateAuthorWorksInfo(data).then(res => {
        if (res.code == 0) {
          if (!this.hadEditor) {
            this.updateAuthorUserbyEditorId()
          }
          this.toViewProcess() // 更新完之后跳转到流程界面
          this.$message({
            message: 'success',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    async updateAuthorUserbyEditorId () {
      let data = {
        data: {
          authorUserID: this.userId,
          editorID: this.ruleForm.editorId
        }
      }
      const res = await updateAuthorUserbyEditorId(data)
    },
    // 更新作品类型关系、标签
    updateAuthorWorksTypeShip () {
      let data = {
        data: [{
          workTypeId: this.gener,
          workId: this.bookId
        }]
      }
      for (let i in this.bigTagsList) {
        for (let j in this.bigTagsList[i].children) {
          if (this.bigTagsList[i].children[j].select) {
            data.data.push({
              workTypeId: this.bigTagsList[i].children[j].id,
              workId: this.bookId
            })
          }
        }
      }
      // if (data.data.length < 3 ) {
      // 	this.$message({
      // 		showClose: true,
      // 		message: 'At least select two tags for your book',
      // 		type: 'error'
      // 	})
      // 	this.tagsErr = 'At least select two tags for your book'
      // 	return false
      // }
      updateAuthorWorksTypeShip(data).then(res => {
        if (res.code == 0) {
          return true
        }
      })
      return true
    },
    // 更新作品字典集合信息
    updateAuthorWorksSelectedDictionaryList () {
      let data = {
        data: {
          workId: this.bookId,
          dictionaryIds: []
        }
      }
      data.data.dictionaryIds.push(this.bookRating)
      data.data.dictionaryIds.push(this.language)
      data.data.dictionaryIds.push(this.writingtype)
      data.data.dictionaryIds.push(this.selectedTargetReader)
      let res = updateAuthorWorksSelectedDictionaryList(data)
      // let res = updateWorksSelectedDictionaryList(data)
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 提交章节简述
    SubmitChapter () {
      let data = {
        data: this.chapterDescrition.chapterList
      }
      updateAuthorSketchList(data).then(res => {
        if (res.code == 0) {
          // this.$message({
          // 	message: res.msg,
          // 	type: 'success'
          // })
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // tags选项卡
    // handleClick(tab, event) {
    // 	console.log(tab, event);
    // },
    // 选中tags
    selectTags (e) {
      console.log(e)
    },
    // 选择是否通过
    changeReviewState (e) {
      this.ruleForm.reviewState = e
    },
    // 返回
    routerBack () {
      this.$router.back()
    }
    // 删除设定分类类型
    // deleteSettingType() {
    // 	let data = {
    // 		data: {
    // 			workId: parseInt(this.workId),
    // 			id: parseInt(this.value.id)
    // 		}
    // 	}
    // 	this.$confirm('此操作将删除该分类设定, 是否继续?', '提示', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		type: 'warning'
    // 	}).then(() => {
    // 		deletAuthorWorksSettingType(data).then(res => {
    // 			console.log("shanchu", res);
    // 			if (res.code == 0) {
    // 				this.$message({
    // 					message: res.msg,
    // 					type: 'success'
    // 				})
    // 				this.value = this.worksSettingList[0]
    // 				this.getAuthorWorksSettingTypeList()
    // 			} else {
    // 				this.$message({
    // 					message: res.msg,
    // 					type: 'warning'
    // 				});
    // 			}
    // 		})
    // 	}).catch(() => {
    // 		this.$message({
    // 			type: 'info',
    // 			message: '已取消删除'
    // 		});
    // 	});
    // },
  }
}
</script>

<style lang="scss" scoped="scoped">
	.content {
		padding: 20px;

		.my-ruleForm {
			.el-form-item {
				margin-bottom: 18px;
			}

			.application {
				margin-top: 20px;
				margin-bottom: 20px;

				span {
					font-size: 20px;
				}

			}
		}
	}

	.topics-items {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;

		.leftItemActive {
			background-color: #409EFF;
			color: #FFF;
			border: 1px solid transparent !important;
		}

		.leftItemDisabled {
			background-color: #F5F7FA;
			color: #000;
			border: 1px solid transparent !important;
		}

		.left {
			display: flex;
			flex-direction: column;
			border: 1px solid #666;
			padding: 5px 5px 15px 5px;
			margin-right: 20px;
			box-sizing: border-box;

			&-item {
				margin-top: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid #666;
				width: 160px;
				box-sizing: border-box;
				user-select: none;
			}

			&-item:hover {
				cursor: pointer;
			}
		}

		.tagBox {

			display: flex;
			flex-direction: row;
			// justify-content: flex-start;
			align-items: start;
			flex-wrap: wrap;

			.tag {
				display: flex;
				padding: 3px 6px;
				color: #666;
				user-select: none;

				font-size: 13px;
				border: 1px solid #8d8d8d;
				border-radius: 8px;
				margin: 0 15px 15px 0;
				line-height: 26px;

				&.tag-active {
					border: 1px solid rgb(254, 149, 0);
					color: rgb(254, 149, 0);
				}
			}

			.tag:hover {
				cursor: pointer;
			}
		}

		.tag {
			display: flex;
			padding: 3px 6px;
			color: #666;
			font-size: 13px;
			border: 1px solid #8d8d8d;
			border-radius: 8px;
			margin: 0 15px 15px 0;
			line-height: 26px;

			// img{
			// 	width: 20px;
			// 	height: 20px;
			// 	margin-left: 5px;
			// 	margin-right: -8px;
			// }
			&.tag-active {
				border: 1px solid rgb(254, 149, 0);
				color: rgb(254, 149, 0);
			}
		}

		.tag-active {
			border: 1px solid rgb(254, 149, 0);
			color: rgb(254, 149, 0);
		}
	}

	.mainCharacters_box {
		font-size: 14px;
		color: #ccc;
		margin: 0;

		.chapterContent {
			font-size: 14px;

		}
	}
</style>
